module.exports = __webpack_public_path__ + "static/media/盈浦尚美社区.d8c69051.jpg";